var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConversaUserB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8414 4.21138C16.8414 5.95559 15.4275 7.36954 13.6832 7.36954C13.3029 7.36954 12.9383 7.30232 12.6006 7.17909C13.0986 6.30313 13.3831 5.28988 13.3831 4.21021C13.3831 3.13133 13.099 2.1188 12.6016 1.24328C12.939 1.12031 13.3033 1.05322 13.6832 1.05322C15.4275 1.05322 16.8414 2.46718 16.8414 4.21138Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 15.7915C20.0002 17.5356 17.8573 18.9495 15.241 18.9495C16.0118 18.107 16.5419 17.0495 16.5419 15.7928C16.5419 14.5348 16.0106 13.4763 15.2383 12.6333C17.8546 12.6333 20.0002 14.0472 20.0002 15.7915Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36904 20.0028C11.4389 20.0028 14.7381 18.1175 14.7381 15.7919C14.7381 13.4663 11.4389 11.5811 7.36904 11.5811C3.29923 11.5811 0 13.4663 0 15.7919C0 18.1175 3.29923 20.0028 7.36904 20.0028Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36908 8.42176C9.69469 8.42176 11.58 6.53649 11.58 4.21088C11.58 1.88528 9.69469 0 7.36908 0C5.04348 0 3.1582 1.88528 3.1582 4.21088C3.1582 6.53649 5.04348 8.42176 7.36908 8.42176Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversaUserB);
export default __webpack_public_path__ + "static/media/conversaUserB.07603f0211a46b85cbfd0921215d138f.svg";
export { ForwardRef as ReactComponent };